if (!customElements.get('gowin-services-editorial')) {
  customElements.define('gowin-services-editorial', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.active = -1;
      this.index = this.querySelector('[data-service-index]');
      this.links = [...this.querySelectorAll('[data-service-choice]')];
      this.panels = [...this.querySelectorAll('[data-service-panel]')];
      this.dock = this.querySelector('[data-service-nav]');
      this.previous = this.querySelector('[data-service-previous]');
      this.next = this.querySelector('[data-service-next]');
      this.panels.forEach(panel => { panel.open = false; panel.hidden = true; });
      this.dataset.enhanced = '';
      this.onClick = event => {
        const choice = event.target.closest('[data-service-choice]');
        if (choice) {
          event.preventDefault();
          const position = this.links.indexOf(choice);
          if (position === this.active) this.closeService();
          else this.choose(position);
        } else if (event.target.closest('[data-service-close], [data-service-all]')) {
          this.closeService();
        } else if (event.target.closest('[data-service-previous]')) {
          this.choose(this.active - 1);
        } else if (event.target.closest('[data-service-next]')) {
          if (this.active < this.panels.length - 1) this.choose(this.active + 1);
          else this.closeService();
        }
      };
      this.onKey = event => {
        if (event.key === 'Escape' && this.active !== -1) {
          event.preventDefault();
          this.closeService();
        }
      };
      this.onBlock = event => {
        const position = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
        if (position !== -1) this.choose(position);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      document.addEventListener('shopify:block:select', this.onBlock);
      this.observer = new IntersectionObserver(entries => {
        this.dock.hidden = this.active === -1 || !entries[0].isIntersecting;
        document.body.classList.toggle('gs3-reading-services', !this.dock.hidden);
      });
      this.observer.observe(this);
    }
    scrollToElement(element) {
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      element.scrollIntoView({ behavior, block: 'start' });
    }
    choose(position) {
      if (position < 0 || position >= this.panels.length) return;
      this.active = position;
      this.links.forEach((link, i) => link.setAttribute('aria-expanded', String(i === position)));
      this.panels.forEach((panel, i) => { panel.hidden = i !== position; panel.open = i === position; });
      this.classList.add('gs3-open');
      this.previous.disabled = position === 0;
      this.querySelector('[data-service-count]').textContent = `${String(position + 1).padStart(2, '0')} / ${String(this.panels.length).padStart(2, '0')}`;
      const nextTitle = position < this.panels.length - 1 ? this.links[position + 1].dataset.serviceTitle : this.dataset.backLabel;
      this.querySelector('[data-service-next-label]').textContent = position < this.panels.length - 1 ? this.dataset.nextLabel : this.dataset.completeLabel;
      this.querySelector('[data-service-next-title]').textContent = nextTitle;
      this.next.setAttribute('aria-label', position < this.panels.length - 1 ? `${this.dataset.nextLabel}: ${nextTitle}` : this.dataset.backLabel);
      this.dock.hidden = false;
      document.body.classList.add('gs3-reading-services');
      const panel = this.panels[position];
      this.scrollToElement(panel);
      panel.focus({ preventScroll: true });
    }
    closeService() {
      const previous = this.active;
      this.active = -1;
      this.links.forEach(link => link.setAttribute('aria-expanded', 'false'));
      this.panels.forEach(panel => { panel.open = false; panel.hidden = true; });
      this.classList.remove('gs3-open');
      this.dock.hidden = true;
      document.body.classList.remove('gs3-reading-services');
      this.links[previous]?.focus({ preventScroll: true });
      this.scrollToElement(this.index);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      document.removeEventListener('shopify:block:select', this.onBlock);
      this.observer?.disconnect();
      document.body.classList.remove('gs3-reading-services');
      this.ready = false;
    }
  });
}
